var OdataQueryService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { OdataOperator } from "./odata-operator.model";
import { ODataAction } from "./odata-action.model";
let OdataQueryService = class OdataQueryService {
    static { OdataQueryService_1 = this; }
    constructor() {
    }
    static isStringCheck(maybeNumber) {
        const checkNumber = Number(maybeNumber);
        return isNaN(checkNumber);
    }
    expand(params, ...expandList) {
        return params.set(ODataAction.Expand, expandList.join(","));
    }
    filter(params, ...filters) {
        params = params.append(ODataAction.Filter, filters.join(" " + OdataOperator.And + " "));
        return params;
    }
    buildOperation(firstOperand, operation, secondOperand) {
        if (operation === OdataOperator.Contains) {
            return `contains(cast(${firstOperand.toString()},'Edm.String'),'${secondOperand.trim()}')`;
        }
        if (OdataQueryService_1.isStringCheck(secondOperand)) {
            return `tolower(${firstOperand.toString()}) ${operation} tolower('${secondOperand.trim()}')`;
        }
        else {
            return `${firstOperand.toString()} ${operation} ${secondOperand}`;
        }
    }
    buildFilterWithCollectionSubQuery(group, filterList, operation) {
        let filter = "";
        let count = 0;
        filterList.forEach((item) => {
            if (count > 0)
                filter += ` ${operation} `;
            filter += `${group}/any(m:m/${item})`;
            count++;
        });
        return filter;
    }
    buildFilterWithSubQuery(group, filterList, operation) {
        let filter = "";
        let count = 0;
        filterList.forEach((item) => {
            if (count > 0)
                filter += ` ${operation} `;
            filter += `${group}/${item}`;
            count++;
        });
        return filter;
    }
    buildExpandWithFilter(group, filterList, operation) {
        let filter = group + "($filter = ";
        if (filterList.length > 1 && operation)
            filter += filterList.join(" " + operation + " ");
        else
            filter += filterList[0];
        filter += ")";
        return filter;
    }
    buildFilterFromArray(params, column, filterList) {
        let value = `${column.trim()} ${OdataOperator.In} (`;
        let itemCount = 1;
        // tslint:disable-next-line:forin
        for (const filterListKey in filterList) {
            value += (OdataQueryService_1.isStringCheck(filterList[filterListKey].toString())
                ? `'${filterList[filterListKey].toString().trim()}'`
                : `${filterList[filterListKey].toString().trim()}`)
                + (itemCount < filterList.length ? "," : ")");
            itemCount++;
        }
        params = params.append(ODataAction.Filter, value);
        return params;
    }
    static ctorParameters = () => [];
};
OdataQueryService = OdataQueryService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], OdataQueryService);
export { OdataQueryService };
